import { Injectable } from '@angular/core';
import { NgxPermissionsService } from 'ngx-permissions';
import { BehaviorSubject } from 'rxjs';
import { DataContextService } from 'src/app/_metronic/services/data-context.service';
import { ResultObject } from 'src/app/_metronic/shared/dtos/result-object-dto';
import { UserDTO } from 'src/app/_metronic/shared/dtos/user-dto';


@Injectable({
  providedIn: 'root',
})
export class AuthService {
  currentUser = new BehaviorSubject<UserDTO | null>(null)
  constructor(private permiision:NgxPermissionsService,private dataContext:DataContextService) {}

  getToken() {
    return localStorage.getItem("auth_token");
  }

  getUser() {
    return JSON.parse(localStorage.getItem("auth_user")!);
  }

  setToken(token: string) {
    localStorage.setItem("auth_token", token);
  }


  setUser(user: UserDTO) {
    localStorage.setItem("auth_user", JSON.stringify(user));
  }

  removeToken() {
    localStorage.removeItem("auth_token");
    localStorage.removeItem("auth_user");
  }

  async setPermissions() {
    if(this.currentUser.value){
      this.loadPermissions(this.currentUser.value);
    }
  }

  async loadPermissions(data: UserDTO) {
    this.permiision.flushPermissions();
    let user = data
    if (user.roles.length) {
      let perm_names:string[]= []
      user.roles.forEach(role =>{
        role.permissions.forEach(per => !perm_names.includes(per) ? perm_names.push(per) : '' )
      })
      await this.permiision.loadPermissions(perm_names);
    }
  }

  logOut() {
    this.dataContext.PostData('/dashboard/auth/logout',{}).subscribe({
      next:(value) =>{
        const  response = <ResultObject<any>>value
        if(response.status === 200){
          this.removeToken();
          this.currentUser.next(null)
          document.location.reload();
        }
      }
    })
  }
}
